import { Heading, Text } from "@nbs/ui";
import { STUDY_HOW } from "../data/methodology";
import { MethodologySchema } from "./MethodologySchema";
import { STORY_IMAGES, StoryMedia } from "./StoryMedia";

type StoryHowStepProps = {
  readonly onBack: () => void;
  readonly onContinue: () => void;
};

export function StoryHowStep({ onBack, onContinue }: StoryHowStepProps) {
  const { tessa } = STUDY_HOW;

  return (
    <section
      className="nbs-story-step"
      data-testid="story-how-step"
      aria-labelledby="story-how-heading"
    >
      <div className="nbs-story-how">
        <div className="nbs-story-how__intro nbs-story-dash__intro">
          <div className="nbs-story-dash__intro-title">
            <p className="nbs-story-step__eyebrow">Étape 3 · Méthode</p>
            <Heading level={1} id="story-how-heading">
              {STUDY_HOW.title}
            </Heading>
            <p className="nbs-story-step__question">{STUDY_HOW.question}</p>
            <Text className="nbs-story-step__lead">{STUDY_HOW.lead}</Text>
            <aside className="nbs-story-how__trust" aria-label="Fiabilité des résultats">
              <p className="nbs-story-how__trust-label">Pourquoi on peut s’y fier</p>
              <p className="nbs-story-how__trust-text">{STUDY_HOW.trustNote}</p>
            </aside>
          </div>
          <div className="nbs-story-dash__intro-aside">
            <StoryMedia
              src={STORY_IMAGES.canopy}
              alt="Plantation d’un plant en pépinière, photo CECI"
              caption="Observation de terrain — cadre TESSA"
              ratio="card"
            />
          </div>
        </div>

        <article className="nbs-story-tessa" data-testid="story-tessa-definition">
          <header className="nbs-story-tessa__header">
            <p className="nbs-story-tessa__acronym">{tessa.acronym}</p>
            <Heading level={2}>{tessa.fullName}</Heading>
          </header>
          <Text className="nbs-story-tessa__definition">{tessa.definition}</Text>
          <Text tone="muted" className="nbs-story-tessa__why">
            {tessa.whyItMatters}
          </Text>
          <footer className="nbs-story-tessa__refs">
            <p className="nbs-story-tessa__ref-label">Références consultables</p>
            <ul>
              <li>
                <a
                  className="nbs-text-link"
                  href={tessa.reference.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {tessa.reference.label}
                </a>
              </li>
              <li>
                <a
                  className="nbs-text-link"
                  href={tessa.reference.doiUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Article scientifique (DOI)
                </a>
                <span className="nbs-story-tessa__cite"> — {tessa.reference.citation}</span>
              </li>
            </ul>
          </footer>
        </article>

        <div className="nbs-story-how__schema">
          <Heading level={2}>Schéma méthodologique</Heading>
          <Text tone="muted" className="nbs-story-nesting__hint">
            Template TESSA : six étapes linéaires, puis les services écosystémiques pris en compte.
          </Text>
          <MethodologySchema />
        </div>

        <div className="nbs-story-step__actions">
          <button
            type="button"
            className="nbs-story-step__cta nbs-story-step__cta--ghost"
            onClick={onBack}
          >
            Retour : où sommes-nous ?
          </button>
          <button type="button" className="nbs-story-step__cta" onClick={onContinue}>
            Suite : quelles sont les tendances
          </button>
        </div>
      </div>
    </section>
  );
}
